import types, { ActionCreators } from './types';

const marketingContentComponentERR: ActionCreators['MarketingContentComponentERR'] = (
  errorMessages,
  error,
) => ({
  type: types.MARKETING_CONTENT_COMPONENT_ERR,
  errorMessages,
  error,
});

const marketingContentComponentOK: ActionCreators['MarketingContentComponentOK'] = (id) => ({
  type: types.MARKETING_CONTENT_COMPONENT_OK,
  id,
});

const marketingContentUpdate: ActionCreators['MarketingContentUpdate'] = (key, value) => ({
  type: types.MARKETING_CONTENT_UPDATE,
  key,
  value,
});

const requestMarketingContent: ActionCreators['RequestMarketingContent'] = (id) => ({
  type: types.REQUEST_MARKETING_CONTENT,
  id,
});

const requestMarketingContentERR: ActionCreators['RequestMarketingContentERR'] = (
  errorMessages,
  error,
) => ({
  type: types.REQUEST_MARKETING_CONTENT_ERR,
  errorMessages,
  error,
});

const requestMarketingContentOK: ActionCreators['RequestMarketingContentOK'] = (
  marketingContent,
) => ({
  type: types.REQUEST_MARKETING_CONTENT_OK,
  marketingContent,
});

const requestMarketingContentsOK: ActionCreators['RequestMarketingContentsOK'] = () => ({
  type: types.REQUEST_MARKETING_CONTENTS_OK,
});

const resetInitialMarketingContentState: ActionCreators['ResetInitialMarketingContentState'] = (
  marketingContent,
) => ({
  type: types.RESET_INITIAL_MARKETING_CONTENT_STATE,
  marketingContent,
});

const actions = {
  marketingContentComponentERR,
  marketingContentComponentOK,
  marketingContentUpdate,
  requestMarketingContent,
  requestMarketingContentERR,
  requestMarketingContentOK,
  requestMarketingContentsOK,
  resetInitialMarketingContentState,
};
export default actions;
